<template>
  <div align="center">
    <!-- <pre>{{this.data_sensor}}</pre> -->
    <h3>Center Plant</h3><br>
    <!-- <p>Exporting the W3C Example Table</p> -->
    <table id="testTable" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides"
      border="2">
      <!-- <caption>
        CODE-PAGE SUPPORT IN MICROSOFT WINDOWS
        <h1 style="color: blue">A Blue Heading</h1>
      </caption> -->
      <colgroup align="center"></colgroup>
      <colgroup align="left"></colgroup>
      <colgroup span="2" align="center"></colgroup>
      <colgroup span="3" align="center"></colgroup>
      <thead valign="top">
        <tr>
          <th>Lorem ipsum dolor sit amet<br />ID</th>
          <th>Name</th>
          <th>Lorem ipsum</th>
          <th>Lorem ipsum</th>
          <th>Power consumption<br />xxxx</th>
          <th>Wastewater Consumption<br />xxxx</th>
          <th>xxxxx<br />x</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>437</td>
          <td>Lorem ipsum dolor sit amet</td>
          <td></td>
          <td>X</td>
          <td>X</td>
          <td>X</td>
          <td>X</td>
        </tr>
        <tr>
          <td>708</td>
          <td>Lorem ipsum dolor sit amet</td>
          <td></td>
          <td>X</td>
          <td></td>
          <td></td>
          <td>X</td>
        </tr>
        <tr>
          <td>710</td>
          <td>Lorem ipsum dolor sit amet</td>
          <td></td>
          <td>X</td>
          <td></td>
          <td></td>
          <td>X</td>
        </tr>
        <tr>
          <td>720</td>
          <td>Lorem ipsum dolor sit amet</td>
          <td></td>
          <td>X</td>
          <td></td>
          <td></td>
          <td>X</td>
        </tr>
      </tbody>
    </table>
    <vs-row class="mt-4" vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-button color="success" class="btnSub" @click="tableToExcel('testTable', 'W3C Example Table')"
          type="filled">Download</vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    table: "testTable",
    name: "W3C Example Table",
    data_sensor: [],
    users: [
      {
        name: "813",
        email: "2021-09-17 08:00:00",
      },
      {
        name: "783",
        email: "2021-09-16 08:00:00",
      },
      {
        name: "123",
        email: "2021-09-15 08:00:00",
      },
      {
        name: "763",
        email: "2021-09-14 08:00:00",
      },
      {
        name: "333",
        email: "2021-09-13 08:00:00",
      },
      {
        name: "365",
        email: "2021-09-12 08:00:00",
      },
      {
        name: "153",
        email: "2021-09-11 08:00:00",
      },

      {
        name: "813",
        email: "2021-09-10 08:00:00",
      },
      {
        name: "783",
        email: "2021-09-9 08:00:00",
      },
      {
        name: "123",
        email: "2021-09-8 08:00:00",
      },
    ],
    items: [
      { age: 40, first_name: "Dickerson", last_name: "Macdonald" },
      { age: 21, first_name: "Larsen", last_name: "Shaw" },
      {
        age: 89,
        first_name: "Geneva",
        last_name: "Wilson",
        _rowVariant: "danger",
      },
      {
        age: 40,
        first_name: "Thor",
        last_name: "MacDonald",
        _cellVariants: { age: "info", first_name: "warning" },
      },
      { age: 29, first_name: "Dick", last_name: "Dunlap" },
    ],
  }),
  methods: {
    tableToExcel(table1, name1) {
      console.log(table1 + name1);
      var uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      if (!table1.nodeType) table1 = document.getElementById(table1);
      var ctx = { worksheet: name1 || "Worksheet", table: table1.innerHTML };

      window.location.href = uri + base64(format(template, ctx));
      return window.location.href;
    },
  },
  mounted() {
    this.$API.get("indoorsensor").then((result) => {
      this.data_sensor = result.data;
    });
  },
};
</script>

<style scoped>
.btnSub {
  width: 100px;
  border-radius: 20px;
}

.cardRadi {
  border-radius: 20px;
}
</style>